import { NgModule } from "@angular/core";
import { CurrencyFormatterPipe } from "./currency-formatter/currency-formatter.pipe";
import { FilterKeywordsPipe } from "./filter-keywords";
import { FilterDataPipe } from "./filter-data.pipe";
import { HighlightSearchPipe } from "./highlight-search.pipe";
import { TruncateTextPipe } from "./truncatetext/truncatetext.pipe";
import { FormatPhoneNumberPipe } from "./format-phone-number/format-phone-number.pipe";
import { SafeurlPipe } from "./safeurl/safeurl.pipe";
import { DateFormatPipe } from './date-format/date-format.pipe';
import { JackpotFormatPipe } from "./jackpot-format/jackpot-format.pipe";


@NgModule({
    declarations:[
        CurrencyFormatterPipe,
        FormatPhoneNumberPipe,
        SafeurlPipe,
        FilterDataPipe,
        HighlightSearchPipe,
        FilterDataPipe,
        TruncateTextPipe,
        FilterKeywordsPipe,
        DateFormatPipe,
        JackpotFormatPipe
    ],
    exports:[
        CurrencyFormatterPipe,
        FormatPhoneNumberPipe,
        SafeurlPipe,
        FilterDataPipe,
        HighlightSearchPipe,
        FilterDataPipe,
        TruncateTextPipe,
        FilterKeywordsPipe,
        DateFormatPipe,
        JackpotFormatPipe
    ]
})

export class PipesModule{}